export enum ErrorCode {
  communityRequestPending = "community_request_pending",
  communityRequestRejected = "community_request_rejected",
  googleVerify = "google_verify_error",
  passwordStrength = "password.password_strength",
}

export class ServerError {
  private message: string;

  private code?: number | string;

  private metadata?: Record<string, string>;

  private pointer?: string;

  constructor(
    message: string,
    url: string,
    code?: number | string,
    pointer?: string,
    metadata?: Record<string, string>,
  ) {
    this.message = message;
    this.code = code;
    this.pointer = pointer;
    this.metadata = metadata;
    console.error("Error", message, url, code);
  }

  getMessage() {
    return this.message;
  }

  getCode() {
    return this.code;
  }

  getMetadata() {
    return this.metadata;
  }

  getAttribute(): string {
    return this.pointer?.split("/")?.at(-1) || "";
  }
}
